import { createReactContext, createReactDispatchContext } from "#utils/reactContext";
import { PaymentBatchActionTypes } from "./constants";
import { PaymentBatchData, PaymentBatchReducerAction } from "./types";

export const initialPaymentBatchState: PaymentBatchData = {
  clientName: "",
  batchId: null,
  batchObjectType: "",
  investmentEntityName: "",
  paymentDescription: undefined,
  scheduledPaymentProcessDate: null,
  makerNote: undefined,
  selectedPositions: [],
  numberOfAvailablePositions: 0,
  isBatchOfOne: false,
  batchData: null,
  errorMessage: undefined,
};

/**
 * Reducer for managing payment batch data state.
 */
export const paymentBatchDataReducer = (
  state: PaymentBatchData,
  action: PaymentBatchReducerAction,
): PaymentBatchData => {
  switch (action.type) {
    case PaymentBatchActionTypes.SET_SELECT_POSITIONS_DATA: {
      return {
        ...state,
        clientName: action.payload.clientName ?? state.clientName,
        investmentEntityName: action.payload.investmentEntityName ?? state.investmentEntityName,
        batchObjectType: action.payload.batchObjectType ?? state.batchObjectType,
        selectedPositions: action.payload.selectedPositions ?? state.selectedPositions,
        numberOfAvailablePositions:
          action.payload.numberOfAvailablePositions ?? state.numberOfAvailablePositions,
      };
    }
    case PaymentBatchActionTypes.SET_PAYMENT_DETAILS: {
      return {
        ...state,
        paymentDescription: action.payload.paymentDescription,
        scheduledPaymentProcessDate:
          action.payload.scheduledPaymentProcessDate ?? state.scheduledPaymentProcessDate,
        makerNote: action.payload.makerNote,
      };
    }
    case PaymentBatchActionTypes.SET_SELECTED_POSITIONS: {
      return {
        ...state,
        selectedPositions: action.payload.selectedPositions ?? state.selectedPositions,
      };
    }
    case PaymentBatchActionTypes.SET_BATCH_DATA: {
      return {
        ...state,
        batchData: action.payload.batchData,
      };
    }
    case PaymentBatchActionTypes.SET_BATCH_OF_ONE: {
      return {
        ...state,
        isBatchOfOne: true,
      };
    }
    case PaymentBatchActionTypes.SET_ERROR_MESSAGE: {
      return { ...state, errorMessage: action.payload.errorMessage };
    }
    default: {
      return state;
    }
  }
};

// Data context (read-only state)
const [usePaymentBatchDataContext, PaymentBatchDataContextProvider] =
  createReactContext<PaymentBatchData>();
export { usePaymentBatchDataContext, PaymentBatchDataContextProvider };

// Dispatch context (for dispatching actions)
const [usePaymentBatchDispatch, PaymentBatchDispatchProvider] =
  createReactDispatchContext<PaymentBatchReducerAction>();
export { usePaymentBatchDispatch, PaymentBatchDispatchProvider };
